export default {
  data() {
    return {
      companyBranches: {
        loading: false,
        pagination: {
          page: 1,
          perPage: 10,
          total: 0,
          totalPages: 0,
        },
        details: {},
        list: [],
        filters: {
          users: {
            list: [],
            selected: [],
          },
          status: {
            list: [
              {
                label: "Ativo",
                value: "Ativo",
              },
              {
                label: "Desativado",
                value: "Desativado",
              },
            ],
            selected: [],
          },
          period: {
            selected: [],
          },
          companyId: "",
          searchTerm: "",
          order: "desc",
          orderBy: "created",
        },
      },
    };
  },
  methods: {
    changeCompanyBranchPage(current) {
      this.companyBranches.pagination.page = current;
      this.getCompanyBranch();
    },
    changeCompanyBranchPageSize(current, pageSize) {
      this.companyBranches.pagination.page = current;
      this.companyBranches.pagination.perPage = pageSize;
      this.getCompanyBranch();
    },
    companyBranchesTableChange(pagination, filters, sorter) {
      filters;
      pagination;
      this.companyBranches.filters.order =
        sorter.order != undefined ? sorter.order : "desc";
      this.companyBranches.filters.orderBy =
        sorter.column != undefined ? sorter.column.key : "created";
      this.getCompanyBranch();
    },
    getCompanyBranches(samePage) {
      let filters = "";

      this.companyBranches.loading = true;

      if (this.companyBranches.filters.searchTerm) {
        filters += `&s=${this.companyBranches.filters.searchTerm}`;
      }

      if (this.companyBranches.filters.status.selected.length > 0) {
        filters += `&status=${this.companyBranches.filters.status.selected}`;
      }

      if (this.companyBranches.filters.users.selected.length > 0) {
        filters += `&user_id=${this.companyBranches.filters.users.selected}`;
      }

      if (this.companyBranches.filters.companyId) {
        filters += `&company_id=${this.companyBranches.filters.companyId}`;
      }

      filters += `&order=${this.companyBranches.filters.order}&order-by=${this.companyBranches.filters.orderBy}`;

      this.$http
        .get(
          `/company-branch/list?page=${this.companyBranches.pagination.page}&per_page=${this.companyBranches.pagination.perPage}${filters}`
        )
        .then(({ data }) => {
          if (!samePage) {
            this.companyBranches.pagination.page = 1;
          }
          this.companyBranches.pagination.total = data.meta.total;
          this.companyBranches.pagination.totalPages = data.meta.total_pages;
          this.companyBranches.list = data.data;
          this.companyBranches.loading = false;
        })
        .catch(({ response }) => {
          this.companyBranches.loading = false;
          this.companyBranches.list = response.data.data;
          this.companyBranches.pagination.total = response.data.meta.total;
          this.companyBranches.pagination.totalPages =
            response.data.meta.total_pages;
        });
    },
  },
};
